var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('div',[(_vm.data.fixedLogistics === 1 && _vm.type === 'picker')?_c('div'):_c('div',[(
        _vm.data.goodsLogistics &&
        _vm.data.goodsLogistics.selfSupport === 1 &&
        !_vm.data.advanceSale
      )?_c('new-html-part',{attrs:{"data":_vm.data}}):_c('old-html-part',{attrs:{"data":_vm.data,"type":_vm.type}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }